// src/components/documents/LineDescription.js — linetext-4d8b2e61 (Stage 2, web)
//
// THE way a line-item description is shown on every web screen (staff estimate and invoice views, job quick
// view, the customer portal, the job profitability report). Same rules as the PDF and the emails, from the
// same formatter (src/utils/lineText.js, generated from functions/utils/lineText.js):
//   - Enter = a new line; one blank line kept; leading spaces indent (0.5em a space);
//   - "- " / "* " = a bullet: two columns, the "•" in a fixed column and the text in the next, so every
//     wrapped line starts exactly under the first letter of the text;
//   - plain text only — React escapes it; nothing is ever read as HTML.
// It renders only the CONTENT: put it inside the element that already styles the description (its size,
// colour and line-through stay that element's). A plain one-line description renders as the bare text,
// exactly as before. src/utils/lineDescriptionGuard.test.js fails if a screen shows a line description
// any other way.
import React from 'react';
import { LINE_TEXT_BULLET_EM, lineTextBlocks, lineTextIndentEm, lineTextIsPlain } from '../../utils/lineText';

const BULLET_ROW = { display: 'flex', alignItems: 'baseline' };
const BULLET = { flex: 'none', width: `${LINE_TEXT_BULLET_EM}em` };
const BULLET_TEXT = { flex: '1 1 auto', minWidth: 0, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' };
const LINE = { display: 'block', whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' };
const BLANK = { display: 'block' };

export default function LineDescription({ text }) {
    if (text === null || text === undefined || text === '') return null;
    if (lineTextIsPlain(text)) return String(text);
    return lineTextBlocks(text).map((b, i) => {
        const indent = lineTextIndentEm(b);
        if (b.kind === 'blank') return <span key={i} style={BLANK}>{' '}</span>;
        if (b.kind === 'text') return <span key={i} style={indent ? { ...LINE, paddingLeft: `${indent}em` } : LINE}>{b.text}</span>;
        return (
            <span key={i} data-line-bullet="" style={indent ? { ...BULLET_ROW, paddingLeft: `${indent}em` } : BULLET_ROW}>
                <span aria-hidden="true" style={BULLET}>•</span>
                <span style={BULLET_TEXT}>{b.text}</span>
            </span>
        );
    });
}
